import { AppValues } from '@/helpers/const';

/**
 * Maps the backend's mobile verification error codes to a message an applicant can act on.
 * The register verify-otp endpoint answers both an incorrect and an expired code with
 * `invalid-otp-code-error`, so the two share a message.
 */
const VERIFY_OTP_ERROR_MESSAGES: Record<string, string> = {
  'invalid-otp-code-error':
    'The verification code is incorrect or has expired. Please check the code, or click "Send code" to get a new one.',
  'invalid-mobile-phone-number-error': `We couldn't verify this mobile number. Please check it is correct, or contact us on ${AppValues.CONTACT}.`,
};

export const getVerifyOtpErrorMessage = (error: string | undefined): string =>
  (error && VERIFY_OTP_ERROR_MESSAGES[error]) ||
  `We couldn't verify your mobile number. Please try again, or contact us on ${AppValues.CONTACT}.`;
